/* eslint-disable no-underscore-dangle */
import * as routerAction from 'react-router-redux';
import { parse, format } from 'url';
import Store from '../store';
import { isWechat } from './sns';

const whiteList = [
    'aliid',
    'forcePlateNum',
    'openid',
    'channel',
    '_source',
    '_flag',
    '__all__',
    'redirect',
    'bind_required',
    'from',
    'x_force_payment_channel',
];

const queryFilters = () => {
    const obj = Store.getState().routing.locationBeforeTransitions.query;
    return Object.keys(obj).filter((k) => whiteList.includes(k)).reduce((total, key) => {
        total[key] = obj[key];
        return total;
    }, {});
};

export const go = (params) => {
    params = typeof params === 'string' ? { pathname: params } : params;
    params.query = Object.assign({}, queryFilters(), {
        plateNum: undefined,
    }, params.query || {});
    Store.dispatch(routerAction.push(params));
};

export const redirect = (params) => {
    params = typeof params === 'string' ? { pathname: params } : params;
    params.query = Object.assign({}, queryFilters(), {
        plateNum: undefined,
    }, params.query || {});
    Store.dispatch(routerAction.replace(params));
};

export const goBack = (...params) => Store.dispatch(routerAction.goBack(...params));

export const goForward = (...params) => Store.dispatch(routerAction.goForward(...params));

export const goHistory = (...params) => Store.dispatch(routerAction.go(...params));

export const setTitle = (title) => {
    Store.app.setTitle({ title });
};

export const reload = () => {
    const url = parse(window.location.href, true);
    window.location.replace(format({
        protocol: url.protocol,
        host: url.host,
        pathname: url.pathname,
        query: Object.assign({}, url.query, {
            _t: new Date().getTime(),
        }),
    }));
};

export const setQuery = (query) => {
    const url = parse(window.location.href, true);
    redirect({
        protocol: url.protocol,
        host: url.host,
        pathname: url.pathname,
        hash: url.hash,
        query: { ...url.query, ...query },
    });
};

export const reloadOnce = () => {
    const url = parse(location.href, true);
    if (url.query._reload === 'true') {
        setQuery({ _reload: undefined });
        return Promise.resolve();
    }

    let host = url.host;
    if (isWechat) {
        host = host.replace('h6.epopark.com', 'h5.epopark.com');
    }

    window.location.replace(format({
        protocol: url.protocol,
        host,
        pathname: url.pathname,
        query: Object.assign({}, url.query, {
            _t: new Date().getTime(),
            _reload: true,
        }),
    }));
    return new Promise(() => {
    });
};

export const wait = (ms) => (data) => {
    return new Promise((rec) => {
        setTimeout(() => {
            rec(data);
        }, ms);
    });
};
